import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
var paddingSpaceOnMedium = 6;
export var Box = styled.div.withConfig({
  componentId: "sc-we6x8g-0"
})(function (_ref) {
  var $backgroundColor = _ref.$backgroundColor,
    $hasImage = _ref.$hasImage,
    $imageVisibilityBreakpoint = _ref.$imageVisibilityBreakpoint,
    $imagePosition = _ref.$imagePosition,
    $imagePullUpSpaceOnLarge = _ref.$imagePullUpSpaceOnLarge,
    $cssPosition = _ref.$cssPosition,
    theme = _ref.theme;
  return css(["padding:", " ", ";background:", ";", " ", "{display:grid;grid-gap:", ";grid-template-columns:repeat(", ",auto);padding:", ";}", "{", " ", "}"], space(4), space(3), getColor(theme, $backgroundColor), $cssPosition && css(["position:", ";"], $cssPosition), breakpoint($imageVisibilityBreakpoint), space(3), $hasImage ? 2 : 1, space(paddingSpaceOnMedium), breakpoint("large"), $hasImage ? css(["", ""], $imagePosition === "right" ? css(["grid-template-columns:auto max-content;"]) : css(["grid-template-columns:max-content auto;"])) : css(["grid-template-columns:auto;"]), $imagePullUpSpaceOnLarge && css(["margin-top:", ";"], space($imagePullUpSpaceOnLarge)));
});
export var StyledImage = styled.div.withConfig({
  componentId: "sc-we6x8g-1"
})(function (_ref2) {
  var $hasImageStickyToBottom = _ref2.$hasImageStickyToBottom,
    $imagePullUpSpaceOnLarge = _ref2.$imagePullUpSpaceOnLarge;
  return css(["", " ", ""], $hasImageStickyToBottom && css(["margin-bottom:", ";"], space(-1 * paddingSpaceOnMedium)), $imagePullUpSpaceOnLarge && css(["", "{height:calc( 100% + ", " );width:100%;margin-top:", ";}"], breakpoint("large"), space(($hasImageStickyToBottom ? 2 : 1) * paddingSpaceOnMedium + $imagePullUpSpaceOnLarge), space(-1 * (paddingSpaceOnMedium + $imagePullUpSpaceOnLarge))));
});
export var ImageWrapper = styled.div.withConfig({
  componentId: "sc-we6x8g-2"
})(function (_ref3) {
  var $hasImageStickyToBottom = _ref3.$hasImageStickyToBottom,
    $imageVisibilityBreakpoint = _ref3.$imageVisibilityBreakpoint,
    $imagePosition = _ref3.$imagePosition;
  return css(["", "{display:none;}", " ", ""], breakpoint("small", $imageVisibilityBreakpoint), $imagePosition === "left" && css(["order:-1;"]), $hasImageStickyToBottom && css(["display:flex;align-items:flex-end;"]));
});